import React from 'react';
import Localize from 'react-intl-universal';

import { Field } from 'formik';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

const CheckboxGroupInputFields = ({
  groupLabel,
  options,
  formArrayName = '',
  formArrayIndex,
  setValues,
  values,
  incrementLabelName
}) => {
  return (
    <FormControl component='fieldset'>
      {groupLabel && <FormLabel component='legend'>{groupLabel}</FormLabel>}
      <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {options.map((option, index) => (
          <Field
            key={index}
            name={formArrayName ? `${formArrayName}.${formArrayIndex}.${option.name}` : option.name}
          >
            {({ field }) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={!!field.value}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          additionalInfo: values.additionalInfo.map((v, i) =>
                            i === formArrayIndex
                              ? {
                                  ...v,
                                  [option.name]: e.target.checked
                                }
                              : v
                          )
                        });
                      }}
                    />
                  }
                  label={`${Localize.get(option.label, '')} ${incrementLabelName ? ` ${index + 1}` : ''}`}
                />
              );
            }}
          </Field>
        ))}
      </Box>
    </FormControl>
  );
};

export default CheckboxGroupInputFields;
